document.addEventListener('DOMContentLoaded', async () => {
  const DISCOUNT_CODE = 'TEST-HERBS';
  const VARIANT_ID = 10897763213;

  const params = new URLSearchParams(window.location.search);

  if (params.get('discount') !== DISCOUNT_CODE) return;

  const discountAppliedKey = `discount-applied-${DISCOUNT_CODE}`;

  // Evita loops
  if (sessionStorage.getItem(discountAppliedKey)) return;
  sessionStorage.setItem(discountAppliedKey, 'true');

  

  // 2. Luego agregar al carrito
  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [{
        id: VARIANT_ID,
        quantity: 1
      }]
    })
  });

  // 1. Primero aplicar discount (ESTO ES CLAVE)
  await fetch(`/discount/${DISCOUNT_CODE}`);

  // 3. Redirigir al carrito (no home)
  window.location.href = '/checkout';
});